export const THEME_COLORS = {
  light: '#f8fafc',
  dark: '#0a0a0a',
} as const;

export type ThemeColorMode = keyof typeof THEME_COLORS;

const THEME_COLOR_SELECTOR = 'meta[name="theme-color"]';

/**
 * Points every `theme-color` meta tag at the app background of the given mode,
 * so the browser toolbar and the installed PWA status bar match the page.
 *
 * @param mode - Resolved theme mode of the app.
 * @param doc - Document holding the meta tags.
 */
export function applyThemeColor(mode: ThemeColorMode, doc: Document = document): void {
  doc.querySelectorAll<HTMLMetaElement>(THEME_COLOR_SELECTOR).forEach((meta) => {
    meta.content = THEME_COLORS[mode];
  });
}
